import GlobalWrapper from './GlobalWrapper';

export default GlobalWrapper;
